import {
  Skeleton,
  TableCell,
  TableRow,
  Grid,
  Card,
  CardContent,
  Divider,
} from "@mui/material";
import React from "react";

export function UsersTableLoader({ rows }) {
  return [...Array(rows)].map((elementInArray, index) => (
    <TableRow hover tabIndex={-1} key={index}>
      <TableCell align="left">
        <Skeleton variant="rectangular"  sx={{ my: 1.5 }} />
      </TableCell>
      <TableCell align="left">
        <Skeleton variant="rectangular" sx={{ my: 1.5 }} />
      </TableCell>
      <TableCell align="left">
        <Skeleton variant="rectangular" sx={{ my: 1.5 }} />
      </TableCell>
      <TableCell align="left">
        <Skeleton variant="rectangular" sx={{ my: 1.5 }} />
      </TableCell>
      <TableCell align="left">
        <Skeleton variant="rectangular" sx={{ my: 1.5 }} />
      </TableCell>
      <TableCell align="left">
        <Skeleton variant="rectangular"  sx={{ my: 1.5 }} />
      </TableCell>
      <TableCell align="left">
        <Skeleton variant="rectangular" sx={{ my: 1.5 }} />
      </TableCell>
    </TableRow>
  ));
}

export function DashboardTableLoader({ rows }) {
  return [...Array(rows)].map((elementInArray, index) => (
    <TableRow hover tabIndex={-1} key={index}>
      <TableCell align="left">
        <Skeleton variant="rectangular" sx={{ my: 1.5 }} />
      </TableCell>
      <TableCell align="left">
        <Skeleton variant="rectangular" sx={{ my: 1.5 }} />
      </TableCell>
      <TableCell align="left">
        <Skeleton variant="rectangular" sx={{ my: 1.5 }} />
      </TableCell>
      <TableCell align="left">
        <Skeleton variant="rectangular" sx={{ my: 1.5 }} />
      </TableCell>
      <TableCell align="left">
        <Skeleton variant="rectangular" sx={{ my: 1.5 }} />
      </TableCell>
      <TableCell align="left">
        <Skeleton variant="rectangular"  sx={{ my: 1.5 }} />
      </TableCell>
      <TableCell align="left">
        <Skeleton variant="rectangular" sx={{ my: 1.5 }} />
      </TableCell>
      <TableCell align="left">
        <Skeleton variant="rectangular" sx={{ my: 1.5 }} />
      </TableCell>
    </TableRow>
  ));
}

export function DashboardTableLoader11({ rows }) {
  return [...Array(rows)].map((elementInArray, index) => (
    <TableRow hover tabIndex={-1} key={index}>
      <TableCell align="left">
        <Skeleton variant="rectangular"  sx={{ my: 1.5 }} />
      </TableCell>
      <TableCell align="left">
        <Skeleton variant="rectangular" sx={{ my: 1.5 }} />
      </TableCell>
      <TableCell align="left">
        <Skeleton variant="rectangular" sx={{ my: 1.5 }} />
      </TableCell>
      <TableCell align="left">
        <Skeleton variant="rectangular" sx={{ my: 1.5 }} />
      </TableCell>
      <TableCell align="left">
        <Skeleton variant="rectangular" sx={{ my: 1.5 }} />
      </TableCell>
      <TableCell align="left">
        <Skeleton variant="rectangular"  sx={{ my: 1.5 }} />
      </TableCell>
      <TableCell align="left">
        <Skeleton variant="rectangular" sx={{ my: 1.5 }} />
      </TableCell>
      <TableCell align="left">
        <Skeleton variant="rectangular" sx={{ my: 1.5 }} />
      </TableCell>
      <TableCell align="left">
        <Skeleton variant="rectangular"  sx={{ my: 1.5 }} />
      </TableCell>
      <TableCell align="left">
        <Skeleton variant="rectangular" sx={{ my: 1.5 }} />
      </TableCell>
      <TableCell align="left">
        <Skeleton variant="rectangular" sx={{ my: 1.5 }} />
      </TableCell>
    </TableRow>
  ));
}
export function DashboardTableLoader13({ rows }) {
  return [...Array(rows)].map((elementInArray, index) => (
    <TableRow hover tabIndex={-1} key={index}>
      <TableCell align="left">
        <Skeleton variant="rectangular"  sx={{ my: 1.5 }} />
      </TableCell>
      <TableCell align="left">
        <Skeleton variant="rectangular" sx={{ my: 1.5 }} />
      </TableCell>
      <TableCell align="left">
        <Skeleton variant="rectangular" sx={{ my: 1.5 }} />
      </TableCell>
      <TableCell align="left">
        <Skeleton variant="rectangular" sx={{ my: 1.5 }} />
      </TableCell>
      <TableCell align="left">
        <Skeleton variant="rectangular" sx={{ my: 1.5 }} />
      </TableCell>
      <TableCell align="left">
        <Skeleton variant="rectangular"  sx={{ my: 1.5 }} />
      </TableCell>
      <TableCell align="left">
        <Skeleton variant="rectangular" sx={{ my: 1.5 }} />
      </TableCell>
      <TableCell align="left">
        <Skeleton variant="rectangular" sx={{ my: 1.5 }} />
      </TableCell>
      <TableCell align="left">
        <Skeleton variant="rectangular"  sx={{ my: 1.5 }} />
      </TableCell>
      <TableCell align="left">
        <Skeleton variant="rectangular" sx={{ my: 1.5 }} />
      </TableCell>
      <TableCell align="left">
        <Skeleton variant="rectangular" sx={{ my: 1.5 }} />
      </TableCell>
      <TableCell align="left">
        <Skeleton variant="rectangular" sx={{ my: 1.5 }} />
      </TableCell>
      <TableCell align="left">
        <Skeleton variant="rectangular" sx={{ my: 1.5 }} />
      </TableCell>
    </TableRow>
  ));
}

export function NotificationCard({ rows }) {
  return [...Array(rows)].map((elementInArray, index) => (
    <Card>
      <CardContent>
        <Grid container direction="column">
          <Grid item>
            <Grid container justifyContent="space-between">
              <Grid item>
                <Grid
                  container
                  spacing={2}
                  direction="row"
                  justifyContent="space-between"
                >
                  <Grid item>
                    <Skeleton variant="circular" width={64} height={64} />
                  </Grid>
                  <Grid item>
                    <Grid container direction="column">
                      <Grid item>
                        <Skeleton
                          variant="rectangular"
                          sx={{ mb: 2 }}
                          width={270}
                          height={22}
                        />
                      </Grid>
                      <Grid item>
                        <Skeleton
                          variant="rectangular"
                          sx={{ my: 0 }}
                          width={270}
                          height={22}
                        />
                      </Grid>
                    </Grid>
                  </Grid>
                </Grid>
              </Grid>
              <Grid item>
                <Skeleton variant="rectangular" width={120} height={34} />
              </Grid>
            </Grid>
          </Grid>
        </Grid>
      </CardContent>
      <Divider />
    </Card>
  ));
}

export function NotificationIconCard({ rows }) {
  return [...Array(rows)].map((elementInArray, index) => (
    <Card>
      <CardContent>
        <Grid container direction="column" width={300}>
          <Grid item>
            <Grid container justifyContent="space-between">
              <Grid item>
                <Grid
                  container
                  spacing={2}
                  direction="row"
                  justifyContent="space-between"
                >
                  <Grid item>
                    <Skeleton variant="circular" width={44} height={44} />
                  </Grid>
                  <Grid item>
                    <Grid container direction="column">
                      <Grid item>
                        <Skeleton
                          variant="rectangular"
                          sx={{ mb: 2 }}
                          width={140}
                          height={14}
                        />
                      </Grid>
                      <Grid item>
                        <Skeleton
                          variant="rectangular"
                          sx={{ my: 0 }}
                          width={140}
                          height={14}
                        />
                      </Grid>
                    </Grid>
                  </Grid>
                </Grid>
              </Grid>
              <Grid item>
                <Skeleton variant="rectangular" width={60} height={20} />
              </Grid>
            </Grid>
          </Grid>
        </Grid>
      </CardContent>
      <Divider />
    </Card>
  ));
}

export function DepartmentTableLoader({ rows }) {
  return [...Array(rows)].map((elementInArray, index) => (
    <TableRow hover tabIndex={-1} key={index}>
      <TableCell align="left">
        <Skeleton variant="rectangular"  sx={{ my: 1.5 }} />
      </TableCell>
      <TableCell align="left">
        <Skeleton variant="rectangular" sx={{ my: 1.5 }} />
      </TableCell>
      <TableCell align="left">
        <Skeleton variant="rectangular"  sx={{ my: 1.5 }} />
      </TableCell>
      <TableCell align="left">
        <Skeleton variant="rectangular" sx={{ my: 1.5 }} />
      </TableCell>
    </TableRow>
  ));
}
export function TenantTableLoader({ rows }) {
  return [...Array(rows)].map((elementInArray, index) => (
    <TableRow hover tabIndex={-1} key={index}>
      <TableCell align="left">
        <Skeleton variant="rectangular"  sx={{ my: 1.5 }} />
      </TableCell>
      <TableCell align="left">
        <Skeleton variant="rectangular" sx={{ my: 1.5 }} />
      </TableCell>
      <TableCell align="left">
        <Skeleton variant="rectangular" sx={{ my: 1.5 }} />
      </TableCell>
      <TableCell align="left">
        <Skeleton variant="rectangular" sx={{ my: 1.5 }} />
      </TableCell>
      <TableCell align="left">
        <Skeleton variant="rectangular" sx={{ my: 1.5 }} />
      </TableCell>
      <TableCell align="left">
        <Skeleton variant="rectangular" sx={{ my: 1.5 }} />
      </TableCell>
      <TableCell align="left">
        <Skeleton variant="rectangular"  sx={{ my: 1.5 }} />
      </TableCell>
      <TableCell align="left">
        <Skeleton variant="rectangular" sx={{ my: 1.5 }} />
      </TableCell>
      <TableCell align="left">
        <Skeleton variant="rectangular" sx={{ my: 1.5 }} />
      </TableCell>
      <TableCell align="left">
        <Skeleton variant="rectangular" sx={{ my: 1.5 }} />
      </TableCell>
      <TableCell align="left">
        <Skeleton variant="rectangular" sx={{ my: 1.5 }} />
      </TableCell>
      <TableCell align="left">
        <Skeleton variant="rectangular" sx={{ my: 1.5 }} />
      </TableCell>
      <TableCell align="left">
        <Skeleton variant="rectangular"  sx={{ my: 1.5 }} />
      </TableCell>
      <TableCell align="left">
        <Skeleton variant="rectangular" sx={{ my: 1.5 }} />
      </TableCell>
      <TableCell align="left">
        <Skeleton variant="rectangular" sx={{ my: 1.5 }} />
      </TableCell>
      <TableCell align="left">
        <Skeleton variant="rectangular" sx={{ my: 1.5 }} />
      </TableCell>
      <TableCell align="left">
        <Skeleton variant="rectangular" sx={{ my: 1.5 }} />
      </TableCell>
      <TableCell align="left">
        <Skeleton variant="rectangular" sx={{ my: 1.5 }} />
      </TableCell>
      <TableCell align="left">
        <Skeleton variant="rectangular" sx={{ my: 1.5 }} />
      </TableCell>
      <TableCell align="left">
        <Skeleton variant="rectangular" sx={{ my: 1.5 }} />
      </TableCell>
    </TableRow>
  ));
}

export function StaffSupportLoader({ rows }) {
  return [...Array(rows)].map((elementInArray, index) => (
    <TableRow hover tabIndex={-1} key={index}>
      <TableCell align="left">
        <Skeleton variant="rectangular" sx={{ my: 1.5 }} />
      </TableCell>
      <TableCell align="left">
        <Skeleton variant="rectangular" sx={{ my: 1.5 }} />
      </TableCell>
      <TableCell align="left">
        <Skeleton variant="rectangular" sx={{ my: 1.5 }} />
      </TableCell>
      <TableCell align="left">
        <Skeleton variant="rectangular" sx={{ my: 1.5 }} />
      </TableCell>
      <TableCell align="left">
        <Skeleton variant="rectangular" sx={{ my: 1.5 }} />
      </TableCell>
      <TableCell align="left">
        <Skeleton variant="rectangular"  sx={{ my: 1.5 }} />
      </TableCell>
    </TableRow>
  ));
}

export function EmailTemplateLoader({ rows }) {
  return [...Array(rows)].map((elementInArray, index) => (
    <TableRow hover tabIndex={-1} key={index}>
      <TableCell align="left">
        <Skeleton variant="rectangular"  sx={{ my: 1.5 }} />
      </TableCell>
      <TableCell align="left">
        <Skeleton variant="rectangular" sx={{ my: 1.5 }} />
      </TableCell>
      <TableCell align="left">
        <Skeleton variant="rectangular" sx={{ my: 1.5 }} />
      </TableCell>
    </TableRow>
  ));
}

export function IPLoader({ rows }) {
  return [...Array(rows)].map((elementInArray, index) => (
    <TableRow hover tabIndex={-1} key={index}>
      <TableCell align="left">
        <Skeleton variant="rectangular"  sx={{ my: 1.5 }} />
      </TableCell>
      <TableCell align="left">
        <Skeleton variant="rectangular" sx={{ my: 1.5 }} />
      </TableCell>

    </TableRow>
  ));
}

export function UserTableLoader1({ rows }) {
  return [...Array(rows)].map((elementInArray, index) => (
    <TableRow hover tabIndex={-1} key={index}>
      <TableCell align="left">
        <Skeleton variant="rectangular"  sx={{ my: 1.5 }} />
      </TableCell>
      <TableCell align="left">
        <Skeleton variant="rectangular" sx={{ my: 1.5 }} />
      </TableCell>
      <TableCell align="left">
        <Skeleton variant="rectangular" sx={{ my: 1.5 }} />
      </TableCell>
      <TableCell align="left">
        <Skeleton variant="rectangular" sx={{ my: 1.5 }} />
      </TableCell>
      <TableCell align="left">
        <Skeleton variant="rectangular" sx={{ my: 1.5 }} />
      </TableCell>
    </TableRow>
  ));
}

export function PropertyRequestTableLoader({ rows }) {
  return [...Array(rows)].map((elementInArray, index) => (
    <TableRow hover tabIndex={-1} key={index}>
      <TableCell align="left">
        <Skeleton variant="rectangular"  sx={{ my: 1.5 }} />
      </TableCell>
      <TableCell align="left">
        <Skeleton variant="rectangular" sx={{ my: 1.5 }} />
      </TableCell>
      <TableCell align="left">
        <Skeleton variant="rectangular" sx={{ my: 1.5 }} />
      </TableCell>
      <TableCell align="left">
        <Skeleton variant="rectangular" sx={{ my: 1.5 }} />
      </TableCell>
      <TableCell align="left">
        <Skeleton variant="rectangular" sx={{ my: 1.5 }} />
      </TableCell>
      <TableCell align="left">
        <Skeleton variant="rectangular" sx={{ my: 1.5 }} />
      </TableCell>
      <TableCell align="left">
        <Skeleton variant="rectangular"  sx={{ my: 1.5 }} />
      </TableCell>
      <TableCell align="left">
        <Skeleton variant="rectangular" sx={{ my: 1.5 }} />
      </TableCell>
      <TableCell align="left">
        <Skeleton variant="rectangular" sx={{ my: 1.5 }} />
      </TableCell>
      <TableCell align="left">
        <Skeleton variant="rectangular" sx={{ my: 1.5 }} />
      </TableCell>
      <TableCell align="left">
        <Skeleton variant="rectangular" sx={{ my: 1.5 }} />
      </TableCell>
      <TableCell align="left">
        <Skeleton variant="rectangular" sx={{ my: 1.5 }} />
      </TableCell>
    </TableRow>
  ));
}

export function PropertyTableLoader({ rows }) {
  return [...Array(rows)].map((elementInArray, index) => (
    <TableRow hover tabIndex={-1} key={index}>
      <TableCell align="left">
        <Skeleton variant="rectangular"  sx={{ my: 1.5 }} />
      </TableCell>
      <TableCell align="left">
        <Skeleton variant="rectangular" sx={{ my: 1.5 }} />
      </TableCell>
      <TableCell align="left">
        <Skeleton variant="rectangular" sx={{ my: 1.5 }} />
      </TableCell>
      <TableCell align="left">
        <Skeleton variant="rectangular" sx={{ my: 1.5 }} />
      </TableCell>
      <TableCell align="left">
        <Skeleton variant="rectangular" sx={{ my: 1.5 }} />
      </TableCell>
      <TableCell align="left">
        <Skeleton variant="rectangular" sx={{ my: 1.5 }} />
      </TableCell>
      <TableCell align="left">
        <Skeleton variant="rectangular"  sx={{ my: 1.5 }} />
      </TableCell>
      <TableCell align="left">
        <Skeleton variant="rectangular" sx={{ my: 1.5 }} />
      </TableCell>
      <TableCell align="left">
        <Skeleton variant="rectangular" sx={{ my: 1.5 }} />
      </TableCell>
      <TableCell align="left">
        <Skeleton variant="rectangular" sx={{ my: 1.5 }} />
      </TableCell>
   
    </TableRow>
  ));
}

export function PropertyTableLoader9({ rows }) {
  return [...Array(rows)].map((elementInArray, index) => (
    <TableRow hover tabIndex={-1} key={index}>
      <TableCell align="left">
        <Skeleton variant="rectangular"   sx={{ my: 1.5 }} />
      </TableCell>
      <TableCell align="left">
        <Skeleton variant="rectangular" sx={{ my: 1.5 }} />
      </TableCell>
      <TableCell align="left">
        <Skeleton variant="rectangular" sx={{ my: 1.5 }} />
      </TableCell>
      <TableCell align="left">
        <Skeleton variant="rectangular" sx={{ my: 1.5 }} />
      </TableCell>
      <TableCell align="left">
        <Skeleton variant="rectangular" sx={{ my: 1.5 }} />
      </TableCell>
      <TableCell align="left">
        <Skeleton variant="rectangular" sx={{ my: 1.5 }} />
      </TableCell>
      <TableCell align="left">
        <Skeleton variant="rectangular"  sx={{ my: 1.5 }} />
      </TableCell>
      <TableCell align="left">
        <Skeleton variant="rectangular" sx={{ my: 1.5 }} />
      </TableCell>
      <TableCell align="left">
        <Skeleton variant="rectangular" sx={{ my: 1.5 }} />
      </TableCell>
   
   
    </TableRow>
  ));
}
export function PropertyTableLoader10({ rows }) {
  return [...Array(rows)].map((elementInArray, index) => (
    <TableRow hover tabIndex={-1} key={index}>
      <TableCell align="left">
        <Skeleton variant="rectangular"   sx={{ my: 1.5 }} />
      </TableCell>
      <TableCell align="left">
        <Skeleton variant="rectangular" sx={{ my: 1.5 }} />
      </TableCell>
      <TableCell align="left">
        <Skeleton variant="rectangular" sx={{ my: 1.5 }} />
      </TableCell>
      <TableCell align="left">
        <Skeleton variant="rectangular" sx={{ my: 1.5 }} />
      </TableCell>
      <TableCell align="left">
        <Skeleton variant="rectangular" sx={{ my: 1.5 }} />
      </TableCell>
      <TableCell align="left">
        <Skeleton variant="rectangular" sx={{ my: 1.5 }} />
      </TableCell>
      <TableCell align="left">
        <Skeleton variant="rectangular"  sx={{ my: 1.5 }} />
      </TableCell>
      <TableCell align="left">
        <Skeleton variant="rectangular" sx={{ my: 1.5 }} />
      </TableCell>
      <TableCell align="left">
        <Skeleton variant="rectangular" sx={{ my: 1.5 }} />
      </TableCell>
      <TableCell align="left">
        <Skeleton variant="rectangular" sx={{ my: 1.5 }} />
      </TableCell>
   
    </TableRow>
  ));
}

export function PropertyTableLoader17({ rows }) {
  return [...Array(rows)].map((elementInArray, index) => (
    <TableRow hover tabIndex={-1} key={index}>
      <TableCell align="left">
        <Skeleton variant="rectangular"   sx={{ my: 1.5 }} />
      </TableCell>
      <TableCell align="left">
        <Skeleton variant="rectangular" sx={{ my: 1.5 }} />
      </TableCell>
      <TableCell align="left">
        <Skeleton variant="rectangular" sx={{ my: 1.5 }} />
      </TableCell>
      <TableCell align="left">
        <Skeleton variant="rectangular" sx={{ my: 1.5 }} />
      </TableCell>
      <TableCell align="left">
        <Skeleton variant="rectangular" sx={{ my: 1.5 }} />
      </TableCell>
      <TableCell align="left">
        <Skeleton variant="rectangular" sx={{ my: 1.5 }} />
      </TableCell>
      <TableCell align="left">
        <Skeleton variant="rectangular" sx={{ my: 1.5 }} />
      </TableCell>
      <TableCell align="left">
        <Skeleton variant="rectangular"  sx={{ my: 1.5 }} />
      </TableCell>
      <TableCell align="left">
        <Skeleton variant="rectangular" sx={{ my: 1.5 }} />
      </TableCell>
      <TableCell align="left">
        <Skeleton variant="rectangular" sx={{ my: 1.5 }} />
      </TableCell>
      <TableCell align="left">
        <Skeleton variant="rectangular"  sx={{ my: 1.5 }} />
      </TableCell>
      <TableCell align="left">
        <Skeleton variant="rectangular" sx={{ my: 1.5 }} />
      </TableCell>
      <TableCell align="left">
        <Skeleton variant="rectangular" sx={{ my: 1.5 }} />
      </TableCell>
      <TableCell align="left">
        <Skeleton variant="rectangular" sx={{ my: 1.5 }} />
      </TableCell>
      <TableCell align="left">
        <Skeleton variant="rectangular" sx={{ my: 1.5 }} />
      </TableCell>
      <TableCell align="left">
        <Skeleton variant="rectangular" sx={{ my: 1.5 }} />
      </TableCell>
      <TableCell align="left">
        <Skeleton variant="rectangular"  sx={{ my: 1.5 }} />
      </TableCell>
      <TableCell align="left">
        <Skeleton variant="rectangular" sx={{ my: 1.5 }} />
      </TableCell>
      <TableCell align="left">
        <Skeleton variant="rectangular" sx={{ my: 1.5 }} />
      </TableCell>
      <TableCell align="left">
        <Skeleton variant="rectangular" sx={{ my: 1.5 }} />
      </TableCell>
      <TableCell align="left">
        <Skeleton variant="rectangular" sx={{ my: 1.5 }} />
      </TableCell>
    </TableRow>
  ));
}

export function PropertyTableLoader7({ rows }) {
  return [...Array(rows)].map((elementInArray, index) => (
    <TableRow hover tabIndex={-1} key={index}>
      <TableCell align="left">
        <Skeleton variant="rectangular"  sx={{ my: 1.5 }} />
      </TableCell>
      <TableCell align="left">
        <Skeleton variant="rectangular" sx={{ my: 1.5 }} />
      </TableCell>
      <TableCell align="left">
        <Skeleton variant="rectangular" sx={{ my: 1.5 }} />
      </TableCell>
      <TableCell align="left">
        <Skeleton variant="rectangular" sx={{ my: 1.5 }} />
      </TableCell>
      <TableCell align="left">
        <Skeleton variant="rectangular" sx={{ my: 1.5 }} />
      </TableCell>
      <TableCell align="left">
        <Skeleton variant="rectangular" sx={{ my: 1.5 }} />
      </TableCell>
      <TableCell align="left">
        <Skeleton variant="rectangular"  sx={{ my: 1.5 }} />
      </TableCell>
 
   
   
    </TableRow>
  ));
}